import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi";

import GetCountriesResponse = App.Http.Responses.Country.GetCountriesResponse;
import GetCountryResponse = App.Http.Responses.Country.GetCountryResponse;

class CountryApi extends TenantBaseApi {
    /**
     * Get list of Countries
     *
     * - Request: -
     * - Response: GetCountriesResponse
     */
    async index(): Promise<GetCountriesResponse> {
        return this.get<GetCountriesResponse, void>("/countries");
    }

    /**
     * Get specific Country
     *
     * - Request: { id: number }
     * - Response: GetCountryResponse
     */
    async show(countryId: string): Promise<GetCountryResponse> {
        return this.get<GetCountryResponse, void>(`/countries/${countryId}`);
    }
}

export const countryApi = new CountryApi();
